import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

type ChatBoxContextProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  script: unknown; //
  setScript: Dispatch<SetStateAction<HTMLScriptElement | null>>;
  fullScreen?: boolean;
  setFullScreen?: Dispatch<SetStateAction<boolean>>;
};

export const ChatbotContext = createContext<ChatBoxContextProps>({
  isOpen: false,
  setIsOpen: () => {},
  script: null,
  setScript: () => {},
  fullScreen: false,
  setFullScreen: () => {},
});

export const ChatbotProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [script, setScript] = useState<HTMLScriptElement | null>(null);
  const [fullScreen, setFullScreen] = useState<boolean>(false);

  const value: ChatBoxContextProps = {
    isOpen,
    setIsOpen,
    script,
    setScript,
    fullScreen,
    setFullScreen,
  };

  return (
    <ChatbotContext.Provider value={value}>{children}</ChatbotContext.Provider>
  );
};

export const useChatbotContext = () => useContext(ChatbotContext);
